// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoicingEntity  {
    _originalTypeClassName = "Loom.BO.InvoicingEntity";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoicingEntity.translate = translateService;
}
this.Id = null;
this.LegalName = null;
this.VATId = null;
this.TaxOffice = null;
this.AddressLine1 = null;
this.AddressLine2 = null;
this.City = null;
this.PostCode = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
LegalName:any;
VATId:any;
TaxOffice:any;
AddressLine1:any;
AddressLine2:any;
City:any;
PostCode:any;
Country:any;
BankAccount:any;
EmploymentContract:any;
static setCountry = ($this, value) => {
var oldValue = $this.Country;
$this.Country = value;
if (value != null) {
}
}
static setBankAccount = ($this, value) => {
var oldValue = $this.BankAccount;
$this.BankAccount = value;
if (value != null) {
if (oldValue != null && oldValue.InvoicingEntity != null) { oldValue.InvoicingEntity = null; }
if ($this.BankAccount.InvoicingEntity !== $this) {
Domain.BankAccount.setInvoicingEntity(value, $this);
}
}
}
static setEmploymentContract = ($this, value) => {
var oldValue = $this.EmploymentContract;
$this.EmploymentContract = value;
if (value != null) {
if (oldValue != null && oldValue.InvoicingEntity != null) { oldValue.InvoicingEntity = null; }
if ($this.EmploymentContract.InvoicingEntity !== $this) {
Domain.EmploymentContract.setInvoicingEntity(value, $this);
}
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}